import React from 'react';

// @material-ui/core components

// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';

import { Formik, FormikProps } from 'formik';
import {  createServicer } from 'apps/things/app/validations';
import ItemForm from './ServicerForm/ItemForm';
import CardWrapper from '@components/Card/CardWrapper';
import { AdminRegisterServicerInput } from '../../types/clientServiceGlobalTypes';

interface IRTable {
  handleSubmit: (payload: AdminRegisterServicerInput) => void;
  isLoading: boolean;
  item: AdminRegisterServicerInput;
}

const AddItem: React.FC<IRTable> = ({ handleSubmit, isLoading, item }) => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          <Formik
            onSubmit={async (values: any) => handleSubmit(values)}
            initialValues={{
              ...item,
            }}
            validationSchema={createServicer}
            validateOnChange={true}
          >
            {(formBag) => (
              <ItemForm
                formBag={(formBag as unknown) as FormikProps<AdminRegisterServicerInput>}
                disableLoginButton={isLoading}
              />
            )}
          </Formik>
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default AddItem;
